<!--==============================
=            TIMELINE            =
===============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Timeline</div>
      </base-header>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-6 col-sm-12">
        <base-card>
          <div slot="card-header">
            Timeline item default
          </div>
          <div slot="card-subheader"> Conditionally use icons within the v-timeline-item's dot to provide additional
            context.

          </div>
          <div slot="card-body">

            <v-timeline :dense="$vuetify.breakpoint.smAndDown">
              <v-timeline-item color="purple lighten-2" fill-dot right>
                <v-card :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
                  <v-card-title class="purple lighten-2">
                    <v-icon dark size="22" class="mr-4">
                      mdi-magnify
                    </v-icon>
                    <h2 class="text-h4  font-weight-light">
                      Title 1
                    </h2>
                  </v-card-title>
                  <div>

                  </div>
                </v-card>
              </v-timeline-item>

              <v-timeline-item color="amber lighten-1" fill-dot left small>
                <v-card :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
                  <v-card-title class="amber lighten-1 justify-end">
                    <h2 class="text-h4 mr-4 white--text font-weight-light">
                      Title 2
                    </h2>
                    <v-icon dark size="22">
                      mdi-home-outline
                    </v-icon>
                  </v-card-title>
                  <div>

                  </div>
                </v-card>
              </v-timeline-item>

              <v-timeline-item color="cyan lighten-1" fill-dot right>
                <v-card :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
                  <v-card-title class="cyan lighten-1">
                    <v-icon class="mr-4" dark size="22">
                      mdi-email-outline
                    </v-icon>
                    <h2 class="text-h4 white--text font-weight-light">
                      Title 3
                    </h2>
                  </v-card-title>

                </v-card>
              </v-timeline-item>

              <v-timeline-item color="red lighten-1" fill-dot left small>
                <v-card :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
                  <v-card-title class="red lighten-1 justify-end">
                    <h2 class="text-h4 mr-4 white--text font-weight-light">
                      Title 4
                    </h2>
                    <v-icon dark size="22">
                      mdi-account-multiple-outline
                    </v-icon>
                  </v-card-title>

                </v-card>
              </v-timeline-item>

              <v-timeline-item color="green lighten-1" fill-dot right>
                <v-card :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
                  <v-card-title class="green lighten-1">
                    <v-icon class="mr-4" dark size="22">
                      mdi-phone-in-talk
                    </v-icon>
                    <h2 class="text-h4 white--text font-weight-light">
                      Title 5
                    </h2>
                  </v-card-title>

                </v-card>
              </v-timeline-item>
            </v-timeline>
          </div>
        </base-card>

      </v-col>

      <v-col class="col-12 col-md-6 col-sm-12">
        <base-card>
          <div slot="card-header">

            Reverse
          </div>
          <div slot="card-subheader">You can reverse the direction of the timeline items by using the reverse prop. This
            works both in default and dense mode. </div>
          <div slot="card-body">
            <div>
              <v-switch v-model="reverse" label="Toggle reverse"></v-switch>
              <v-timeline :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" :reverse="reverse"
                          :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item v-for="n in 4" :key="n">
                  <span slot="opposite">Tus eu perfecto</span>
                  <v-card :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" class="elevation-2">
                    <v-card-title class="text-h5">
                      Lorem ipsum
                    </v-card-title>
                    <v-card-text>

                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>

            </div>
          </div>
        </base-card>

      </v-col>


    </v-row>


  </div>

</template>
<script>
  const COLORS = [
    'info',
    'warning',
    'error',
    'success',
  ]
  const ICONS = {
    info: 'mdi-information',
    warning: 'mdi-alert',
    error: 'mdi-alert-circle',
    success: 'mdi-check-circle',
  }
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from "../../components/Base/BaseHeader.vue";
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data: () => ({
      interval: null,
      items1: [{
        id: 1,
        color: 'info',
        icon: ICONS.info,
      }, ],
      nonce: 2,
      items: [{
          color: 'red lighten-2',
          icon: 'mdi-star',
        },
        {
          color: 'purple darken-1',
          icon: 'mdi-book-variant',
        },
        {
          color: 'green lighten-1',
          icon: 'mdi-airballoon',
        },
        {
          color: 'indigo',
          icon: 'mdi-buffer',
        },
      ],
      reverse: true,
    }),

    beforeDestroy() {
      this.stop()
    },

    methods: {
      addEvent() {
        let {
          color,
          icon
        } = this.genAlert()

        const previousColor = this.items[0].color

        while (previousColor === color) {
          color = this.genColor()
        }

        this.items.unshift({
          id: this.nonce++,
          color,
          icon,
        })

        if (this.nonce > 6) {
          this.items.pop()
        }
      },
      genAlert() {
        const color = this.genColor()

        return {
          color,
          icon: this.genIcon(color),
        }
      },
      genColor() {
        return COLORS[Math.floor(Math.random() * 3)]
      },
      genIcon(color) {
        return ICONS[color]
      },
      start() {
        this.interval = setInterval(this.addEvent, 3000)
      },
      stop() {
        clearInterval(this.interval)
        this.interval = null
      },
    },
  };
</script>

<!--====  End of TIMELINE  ====-->